import defaultAttributes from '../defaultAttributes';

const TrendingUp = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '22 7 13.5 15.5 8.5 10.5 2 17' }],
    ['polyline', { points: '16 7 22 7 22 13' }],
  ],
];

export default TrendingUp;
